import 'core-js/proposals/reflect-metadata';

import PerfilDTOGenerico from './PerfilDTOGenerico';

class CategoriaEnsinoDTO extends PerfilDTOGenerico {
    constructor() {
        super();
    }
}

export default CategoriaEnsinoDTO;
